/* ============================================================
   Locale-aware Shopify cart endpoints
   ------------------------------------------------------------
   vela_ajaxcart.js (and any third-party code) calls the Shopify
   Ajax cart at hardcoded "/cart.js", "/cart/add.js",
   "/cart/change.js", "/cart/update.js". On Shopify Markets
   storefronts those paths hit the PRIMARY locale (EN) and return
   English product titles — which is why the cart DRAWER flashed
   "Brown cowhide rug M" while the /cart page (server-rendered via
   Liquid) correctly showed "Pelle bovina marrone M".

   Fix: rewrite those URLs on the fly to include the current
   storefront's locale prefix (window.Shopify.routes.root), so
   "/cart.js" on the IT storefront becomes "/it/cart.js". Shopify's
   Ajax API returns locale-translated titles at the locale-scoped
   URL.

   No-op on the primary locale (root === "/").
   ============================================================ */
(function () {
    'use strict';

    function getLocaleRoot() {
        var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (r.charAt(r.length - 1) !== '/') r += '/';
        return r;
    }

    // Matches "/cart", "/cart.js", "/cart/add(.js)", "/cart/change(.js)",
    // "/cart/update(.js)", "/cart/clear(.js)" — with or without a query string.
    // Intentionally does NOT match "/it/cart*" (already localized), "/cart.json",
    // or anything with an absolute host (the pattern requires a leading "/").
    var CART_RE = /^\/cart(?:\.js|\/(?:add|change|update|clear)(?:\.js)?)?(?:[?#]|$)/;

    function localizeCartUrl(url) {
        if (typeof url !== 'string') return url;
        if (!CART_RE.test(url)) return url;
        var root = getLocaleRoot();
        if (root === '/') return url;
        return root.replace(/\/$/, '') + url;
    }

    // Wrap jQuery.ajax — vela_ajaxcart.js uses this.
    if (window.jQuery && typeof window.jQuery.ajax === 'function' && !window.jQuery.ajax.__nsWrapped) {
        var origAjax = window.jQuery.ajax;
        var wrappedAjax = function (urlOrOptions, options) {
            // Two call signatures: $.ajax(url, options) or $.ajax(options)
            if (typeof urlOrOptions === 'string') {
                urlOrOptions = localizeCartUrl(urlOrOptions);
            } else if (urlOrOptions && typeof urlOrOptions === 'object') {
                if (urlOrOptions.url) urlOrOptions.url = localizeCartUrl(urlOrOptions.url);
            }
            return origAjax.call(this, urlOrOptions, options);
        };
        wrappedAjax.__nsWrapped = true;
        // Preserve static properties like $.ajaxSettings
        for (var k in origAjax) {
            if (Object.prototype.hasOwnProperty.call(origAjax, k)) wrappedAjax[k] = origAjax[k];
        }
        window.jQuery.ajax = wrappedAjax;
    }

    // Wrap fetch — for any modern AJAX cart code that uses it.
    if (typeof window.fetch === 'function' && !window.fetch.__nsWrapped) {
        var origFetch = window.fetch.bind(window);
        var wrappedFetch = function (input, init) {
            try {
                if (typeof input === 'string') {
                    input = localizeCartUrl(input);
                } else if (input && typeof input.url === 'string') {
                    var localized = localizeCartUrl(input.url);
                    if (localized !== input.url && typeof Request === 'function') {
                        input = new Request(localized, input);
                    }
                }
            } catch (e) { /* never break fetch */ }
            return origFetch(input, init);
        };
        wrappedFetch.__nsWrapped = true;
        window.fetch = wrappedFetch;
    }
})();

/* ============================================================
   Localization safety net for vela.productPage / selectCallback
   ------------------------------------------------------------
   The theme ships two sibling files: `vela.js` (hardcoded English)
   and `vela.js.liquid` (properly localized with `| t`). Depending on
   how the theme was uploaded / cached, Shopify may serve either one.
   If the English version is served, `vela.productPage()` runs on
   page load (via the template's `$(window).load` selectCallback) and
   synchronously rewrites `#AddToCartText` with "Add to Cart" — which
   flashes over the server-rendered Italian string.

   This wrapper runs immediately after `vela.productPage()` in the
   same JS tick, restoring the localized text from `window.nsStrings`
   (injected via Liquid `| t | json` in vela-footer-javascript.liquid).
   Two writes in one tick = the browser never paints the English
   intermediate state, so no flash is visible.

   This is a no-op when `vela.js.liquid` IS being served (the wrapped
   function already wrote the correct localized string).
   ============================================================ */
(function () {
    'use strict';

    function applyLocalized(variant) {
        var text = document.getElementById('AddToCartText');
        if (!text || !window.nsStrings) return;

        if (variant && variant.available === false) {
            if (window.nsStrings.soldOut && text.textContent !== window.nsStrings.soldOut) {
                text.textContent = window.nsStrings.soldOut;
            }
            return;
        }
        if (!variant) {
            if (window.nsStrings.unavailable && text.textContent !== window.nsStrings.unavailable) {
                text.textContent = window.nsStrings.unavailable;
            }
            return;
        }
        if (window.nsStrings.addToCart && text.textContent !== window.nsStrings.addToCart) {
            text.textContent = window.nsStrings.addToCart;
        }
    }

    function wrap() {
        if (!window.vela || typeof window.vela.productPage !== 'function') return false;
        if (window.vela.productPage.__nsWrapped) return true;

        var orig = window.vela.productPage;
        var wrapped = function (options) {
            var result = orig.apply(this, arguments);
            try {
                applyLocalized(options && options.variant);
            } catch (e) { /* never break the button */ }
            return result;
        };
        wrapped.__nsWrapped = true;
        window.vela.productPage = wrapped;
        return true;
    }

    // vela.js loads before this file, so wrap() should succeed immediately.
    // Retry briefly in case of unusual load ordering.
    if (!wrap()) {
        var tries = 0;
        var iv = setInterval(function () {
            if (wrap() || ++tries > 40) clearInterval(iv);
        }, 50);
    }
})();

/* ============================================================
   Quick-add cart icon for product grid cards
   - Replaces the hover/tap "Add to cart" button that used to
     appear below the image on collection pages.
   - Adds a small transparent cart icon to each product card.
   - Simple products (1 variant): triggers the existing (hidden)
     form submit so the theme's AJAX cart handles the add.
   - Products with multiple variants: navigates to the product
     page so the customer can pick options.
   - Sold out products: no icon.
   ============================================================ */
/* Zoom/expand button — open the current product image(s) in a fancybox
   lightbox. The theme's default handler assumes elevateZoom was set up
   (which only happens when the product has multiple images) so it
   silently errors out on single-image products. This handler runs in the
   capture phase, stops the theme's handler, and works for BOTH cases:
   - Multi-image products: builds a gallery from product.media thumbnails
   - Single-image products: opens just the current main image fullscreen */
(function () {
    'use strict';

    function openLightbox(e) {
        if (!e.target) return;
        var btn = e.target.closest('#velaViewImage');
        if (!btn) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        if (!window.jQuery || !window.jQuery.fancybox) return;
        var $ = window.jQuery;

        var gallery = [];
        document.querySelectorAll(
            '#productThumbs .product-single__thumbnail'
        ).forEach(function (a) {
            var href = a.getAttribute('href') || a.getAttribute('data-zoom-image');
            if (href) gallery.push({ src: href });
        });

        if (gallery.length === 0) {
            var main = document.getElementById('ProductPhotoImg');
            var url = btn.getAttribute('data-master-url') ||
                      (main && (main.getAttribute('data-zoom-image') || main.src));
            if (url) gallery.push({ src: url });
        }

        if (gallery.length === 0) return;

        try {
            $.fancybox.open(gallery);
        } catch (err) {
            window.open(gallery[0].src, '_blank');
        }
    }

    document.addEventListener('click', openLightbox, true);
})();

/* Destroy Owl Carousel on product thumbnails at desktop sizes so our
   CSS-driven vertical thumbnail layout can take over. */
(function () {
    'use strict';

    function stripOwl() {
        if (window.innerWidth < 768) return;
        var wrap = document.getElementById('productThumbs');
        if (!wrap) return;
        var thumbs = wrap.querySelector('.owl-carousel, .product-single__thumbnails');
        if (!thumbs) return;
        try {
            if (window.jQuery) {
                var $t = jQuery(thumbs);
                if ($t.hasClass('owl-loaded')) {
                    $t.trigger('destroy.owl.carousel');
                }
                if ($t.hasClass('slick-initialized')) {
                    $t.slick('unslick');
                }
            }
        } catch (e) { /* ignore */ }
        thumbs.removeAttribute('style');
        wrap.querySelectorAll('[style]').forEach(function (el) {
            el.removeAttribute('style');
        });
        thumbs.classList.remove(
            'owl-carousel', 'owl-loaded', 'owl-drag',
            'owl-hidden', 'owl-refreshed',
            'slick-slider', 'slick-initialized', 'slick-dotted'
        );
        wrap.querySelectorAll(
            '.owl-nav, .owl-dots, .slick-arrow, .slick-prev, ' +
            '.slick-next, .slick-dots, [class*="owl-prev"], [class*="owl-next"]'
        ).forEach(function (el) {
            el.parentNode && el.parentNode.removeChild(el);
        });
    }

    window.addEventListener('load', function () {
        setTimeout(stripOwl, 50);
    });
    var t;
    window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(stripOwl, 150);
    });
})();

/* Thumbnail click → swap main image (fixes vela.js bug) */
(function () {
    'use strict';

    document.addEventListener('click', function (e) {
        var thumb = e.target.closest('.product-single__thumbnail');
        if (!thumb) return;

        var stype = thumb.getAttribute('data-stype');
        if (stype && stype !== 'image') return;

        var newSrc = thumb.getAttribute('data-image');
        if (!newSrc) return;

        var mainImg = document.getElementById('ProductPhotoImg');
        if (!mainImg) return;
        if (mainImg.src === newSrc) return;

        var pre = new Image();
        mainImg.style.opacity = '0.4';
        mainImg.style.transition = 'opacity 0.15s ease';

        pre.onload = function () {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = newSrc;
            mainImg.style.opacity = '1';
        };
        pre.onerror = function () {
            mainImg.style.opacity = '1';
        };
        pre.src = newSrc;
    }, true);
})();

/* Inject quick-add bag icon on every product grid card */
(function () {
    'use strict';

    var ICON_SVG =
        '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path>' +
            '<path d="M3 6h18"></path>' +
            '<path d="M16 10a4 4 0 0 1-8 0"></path>' +
        '</svg>';

    /* Pulls localized labels from window.nsStrings (set in
       vela-footer-javascript.liquid via Shopify's {{ ... | t | json }} so
       Shopify Markets auto-switches per visitor). Falls back to English
       if the global wasn't injected for any reason. */
    function labelSelect() {
        return (window.nsStrings && window.nsStrings.selectOptions) || 'Select options';
    }
    function labelAddToCart() {
        return (window.nsStrings && window.nsStrings.addToCart) || 'Add to cart';
    }

    function inject(block) {
        if (!block || block.querySelector('.quickAddIcon')) return;

        var imgWrap = block.querySelector('.proHImage');
        if (!imgWrap) return;

        var form = block.querySelector('form.formAddToCart');
        if (!form) return;

        var submitEl = form.querySelector('.btnAddToCart');
        if (!submitEl) return;

        if (submitEl.classList.contains('disabled') || submitEl.disabled) return;

        var isVariantProduct = submitEl.tagName === 'A';
        var productUrl = isVariantProduct ? submitEl.getAttribute('href') : null;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quickAddIcon';
        btn.setAttribute(
            'aria-label',
            isVariantProduct ? labelSelect() : labelAddToCart()
        );
        btn.innerHTML = ICON_SVG;

        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (isVariantProduct) {
                if (productUrl) window.location.href = productUrl;
                return;
            }

            btn.classList.add('is-loading');

            try {
                submitEl.click();
            } catch (err) {
                form.submit();
            }

            setTimeout(function () {
                btn.classList.remove('is-loading');
                btn.classList.add('is-added');
                setTimeout(function () {
                    btn.classList.remove('is-added');
                }, 1200);
            }, 400);
        });

        imgWrap.appendChild(btn);
    }

    function injectAllDeferred(root) {
        var blocks = Array.prototype.slice.call(
            (root || document).querySelectorAll('.velaProBlock')
        );
        if (blocks.length === 0) return;

        var runNext = function () {
            var batch = blocks.splice(0, 12);
            batch.forEach(inject);
            if (blocks.length === 0) return;

            if (window.requestIdleCallback) {
                window.requestIdleCallback(runNext, { timeout: 500 });
            } else {
                setTimeout(runNext, 16);
            }
        };
        runNext();
    }

    function ready(fn) {
        if (document.readyState !== 'loading') fn();
        else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
        injectAllDeferred(document);

        if ('MutationObserver' in window) {
            var mo = new MutationObserver(function (mutations) {
                for (var i = 0; i < mutations.length; i++) {
                    var m = mutations[i];
                    for (var j = 0; j < m.addedNodes.length; j++) {
                        var n = m.addedNodes[j];
                        if (n.nodeType !== 1) continue;
                        if (n.classList && n.classList.contains('velaProBlock')) {
                            inject(n);
                        } else {
                            injectAllDeferred(n);
                        }
                    }
                }
            });
            mo.observe(document.body, { childList: true, subtree: true });
        }
    });
})();
